import type { LinearProgressProps } from "@mui/material";

import {
  getProcessBulkCounts,
  isProcessCanceledByUser,
  ProcessStatusEnum,
  type IRydeProcess,
} from "@ryde/shared";

export const resolveProcessProgressColor = (
  currentProcess: IRydeProcess | undefined,
): LinearProgressProps["color"] => {
  if (isProcessCanceledByUser(currentProcess)) {
    return "warning";
  }

  if (currentProcess?.status === ProcessStatusEnum.Failed) {
    return "error";
  }

  if (currentProcess?.status === ProcessStatusEnum.Completed) {
    const { skippedCount, successCount, warningCount } =
      getProcessBulkCounts(currentProcess);
    if (successCount === 0 && skippedCount > 0) {
      return "warning";
    }
    if (skippedCount > 0 || warningCount > 0) {
      return "warning";
    }
    return "success";
  }

  return "primary";
};
